import { dispatchDiscoveryAtworkEvent, dispatchAtWorkEvent } from '../utils/analyticsEvents';
import { useEmailFlow, usePhoneFlow } from '.';
import { redirectToPayroll } from '../utils/redirect';
import { useEmailAndPhoneFlow } from './AddEmailAndPhone';

enum FlowSource {
  LINK = 'link',
  SECTION = 'section',
}

type UseRouteFlowProps = {
  handleOpen: (callback?: () => void) => void;
};

const sourceDispatch = {
  link: dispatchAtWorkEvent,
  section: dispatchDiscoveryAtworkEvent,
};

const openFlows = (fn: () => void): void => {
  fn();
};

const useRouteFlow = (source: FlowSource): UseRouteFlowProps => {
  const { open: openEmailAndPhoneFlow } = useEmailAndPhoneFlow();
  const { open: openPhoneFlow } = usePhoneFlow();
  const { open: openEmailFlow } = useEmailFlow();

  const openCallback = (): void => {
    const dispatch = sourceDispatch[source];

    dispatch();
    redirectToPayroll();
  };

  const handleOpen = (callback?: () => void): void => {
    const emailAndPhoneFlow = (): void => openEmailAndPhoneFlow(callback ?? openCallback);
    const emailFlow = (): void => openEmailFlow(emailAndPhoneFlow);
    const phoneFlow = (): void => openPhoneFlow(emailFlow);

    openFlows(phoneFlow);
  };

  return { handleOpen };
};

export { useRouteFlow, FlowSource };
